import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';

import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {ModalModule} from 'ngx-bootstrap/modal';
import {LeftSideNavigationComponent} from './components/left-side-navigation/left-side-navigation.component';
import {RouterModule} from '@angular/router';
import {HeaderComponent} from './components/header/header.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule} from '@angular/forms';
import {LoginPageComponent} from './components/login-page/login-page.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {ToastrModule} from 'ngx-toastr';
import {NotFoundPageComponent} from './components/not-found-page/not-found-page.component';
import {MatCardModule} from '@angular/material/card';
import {SharedModule} from './modules/shared/shared.module';
import {DashboardComponent} from './components/dashboard/dashboard.component';
import {MatDividerModule} from '@angular/material/divider';
import {NavigationComponent} from './components/navigation/navigation.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {DeleteDialogComponent} from './components/delete-dialog/delete-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import {SpService} from './modules/forms/modules/sp/services/sp.service';
import { ExportDialogComponent } from './components/export-dialog/export-dialog.component';
import { AnnouncementsComponent } from './components/announcements/announcements.component';
import { FormElementsModule } from './modules/form-elements/form-elements.module';

@NgModule({
  imports: [
    BrowserModule,
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    RouterModule,
    BrowserAnimationsModule,
    FormsModule,
    FormElementsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    SharedModule,
    MatDividerModule,
    MatTooltipModule,
    TranslateModule,
    MatProgressSpinnerModule,
    ScrollingModule,
    MatDialogModule
  ],
  declarations: [
    LeftSideNavigationComponent,
    HeaderComponent,
    LoginPageComponent,
    NotFoundPageComponent,
    DashboardComponent,
    NavigationComponent,
    DeleteDialogComponent,
    ExportDialogComponent,
    AnnouncementsComponent
  ],
  exports: [
    LeftSideNavigationComponent,
    HeaderComponent,
    NavigationComponent,
  ],
  providers: [
    SpService
  ]
})
export class AppBootstrapModule {
}

export function HttpLoaderFactory(http: HttpClient): any {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 4000,
      positionClass: 'toast-bottom-right',
    }),
    AppBootstrapModule,
    AppRoutingModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
